/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
    useCallback, useEffect, useContext, useState, useMemo, useRef
} from 'react';
import _ from 'lodash';
import {
    useLocation, withRouter
} from 'react-router-dom';
import {
    ModalNextProvider,
} from '@jutro/components';
import { error } from '@jutro/logger';
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { useAuthentication } from 'gw-digital-auth-react';
import { useValidation } from 'gw-portals-validation-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { TranslatorContext } from '@jutro/locale';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import moment from 'moment';
import messages from '../../PolicyChangeCommon.messages';
import wizardConfig from '../../config/policy-change-wizard-config.json5';
import metadata from './TypeOfChangesPage.metadata.json5';
import styles from '../../PolicyChange.module.scss';
import './TypeOfChangesPage.messages';

function TypeOfChangesPage(props) {
    const { steps } = wizardConfig;
    const { authHeader } = useAuthentication();
    const translator = useContext(TranslatorContext);
    const { EndorsementService } = useDependencies('EndorsementService');
    const {
        wizardData, currentStepIndex, changeNextSteps, updateWizardData, goNext, history
    } = props;
    const location = useLocation();
    const requestType = _.get(location, 'state.requestType', '');
    // Removed: const skipCurrentStep = requestType === 'profileChange'; // No longer needed
    const hasAutoProceededRef = useRef(false);
    const { submissionVM, selectedData } = wizardData;
    const [typeOfChange, updateTypeOfChange] = useState();
    const [shouldAdvance, setShouldAdvance] = useState(false);
    const { isComponentValid, registerComponentValidation } = useValidation(
        'TypeOfChangesPage'
    );
    const codePathMapping = {
        profileChange: '/profile-change',
        mailingaddress: '/mailing-address',
        paperlesspreference: '/paperless-preference'
    };

    const updateAvailableOptions = useCallback((options) => {
        _.forEach(wizardData.selectedData, (value, key) => {
            if (key !== options) {
                _.set(wizardData, `selectedData.${key}`, false);
            }
        });
        updateWizardData(wizardData);
    }, [updateWizardData, wizardData]);

    const handleChange = useCallback(
        (options) => {
            _.set(wizardData, `selectedData.${options}`, true);
            updateWizardData(wizardData);
            updateTypeOfChange(options);
            updateAvailableOptions(options);
        },
        [updateWizardData, wizardData, updateAvailableOptions]
    );

    const saveEndorsementRequest = useCallback(
        () => {
            const typeOfChangeToBeFiltered = ['profileChange', 'mailingaddress', 'paperlesspreference'];

            if (typeOfChangeToBeFiltered.includes(typeOfChange)) {
                _.set(submissionVM.value, 'baseData_Ext.typeOfChanges', [typeOfChange]);
                return _.omit(submissionVM.value, 'lobData');
            }
            return submissionVM.value;
        },
        [submissionVM, typeOfChange]
    );

    const onNext = useCallback(async () => {
        submissionVM.value = await EndorsementService.loadEndorsementWithEffectiveDate(
            [submissionVM.value.policyNumber, submissionVM.value.baseData_Ext.effectiveDate],
            authHeader
        );
        const typeOfChangeToBeFiltered = ['profileChange', 'mailingaddress', 'paperlesspreference'];

        if (typeOfChangeToBeFiltered.includes(typeOfChange)) {
            _.set(submissionVM.value, 'baseData_Ext.typeOfChanges', [typeOfChange]);
        }

        const newSteps = steps.slice(currentStepIndex + 1, steps.length);
        _.forEach(selectedData, (value, key) => {
            if (!value) {
                newSteps.splice(
                    _.findIndex(newSteps, ({ path }) => path === codePathMapping[key]),
                    1
                );
            }
        });
        changeNextSteps(newSteps);
        return wizardData;
    }, [
        typeOfChange,
        EndorsementService,
        submissionVM.value,
        authHeader,
        steps,
        currentStepIndex,
        selectedData,
        changeNextSteps,
        wizardData,
        codePathMapping,
        saveEndorsementRequest
    ]);

    const isProfileChangeSelected = useMemo(() => {
        return typeOfChange === 'profileChange';
    }, [typeOfChange]);

    const checkSelectedData = useCallback(() => {
        return _.some(selectedData);
    }, [selectedData]);

    const generateTypeOfChanges = useCallback(() => {
        const typeOfChanges = _.get(submissionVM.value, 'typeOfChangesforUserDisplay', []);
        if (!_.isEmpty(typeOfChanges)) {
            _.set(wizardData, 'selectedPages', typeOfChanges);
            updateWizardData(wizardData);
        }
    }, [submissionVM.value, updateWizardData, wizardData]);

    useEffect(() => {
        registerComponentValidation(checkSelectedData);
    }, [checkSelectedData, registerComponentValidation]);

    useEffect(() => {
        generateTypeOfChanges();
    // Disabled so we don't rerun this function on every rerender
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (requestType === 'profileChange' && !hasAutoProceededRef.current) {
            // Set selectedData
            _.set(wizardData, 'selectedData.profileChange', true);
            _.set(wizardData, 'selectedData.mailingaddress', false);
            _.set(wizardData, 'selectedData.paperlesspreference', false);
            // Set selectedPages
            _.set(wizardData, 'selectedPages', [
                {
                    displayName: 'Profile Change',
                    code: 'profileChange'
                }
            ]);
            updateWizardData(wizardData);
            updateTypeOfChange('profileChange'); // Ensure typeOfChange is set
            setShouldAdvance(true); // Flag to trigger advance after data is set
            hasAutoProceededRef.current = true;
        }
    }, [requestType, wizardData, updateWizardData]);

    // Auto-advance useEffect with optional delay
    useEffect(() => {
        if (shouldAdvance && typeOfChange === 'profileChange') {
            const advanceWizard = async () => {
                try {
                    await onNext(); // Load data and filter steps
                    goNext(); // Explicitly advance the wizard to the next step
                } catch (err) {
                    error(
                        `ProfileChange: Unable to do policy change ${JSON.stringify(err)}`
                    );
                    ModalNextProvider.showAlert({
                        title: messages.policyRequestFailed,
                        message: messages.CanNotLoadYourPolicyAtThisTime,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: messages.ok
                    }).then(() => history.push('/error'));
                }
                setShouldAdvance(false); // Reset flag to prevent re-runs
            };
            advanceWizard();
        }
    }, [shouldAdvance, typeOfChange, onNext]);


    const getEffectiveDate = useCallback(() => {
        const now = moment();
        const effectiveDate = _.get(submissionVM, 'baseData_Ext.effectiveDate.value');
        if (isProfileChangeSelected) {
            if (now.isBefore(effectiveDate)) {
                return effectiveDate;
            }
            return new Date();
        }
        return effectiveDate;
    }, [submissionVM, isProfileChangeSelected]);

    const overrideProps = {
        '@field': {
            labelPosition: 'left'
        },
        selectionRadioButton: {
            value: typeOfChange || _.keys(_.pickBy(wizardData.selectedData)),
            onValueChange: handleChange
        },
        policyChangeEffectiveDateId: {
            value: getEffectiveDate(),
            disabled: isProfileChangeSelected,
            minDate: _.get(submissionVM, 'baseData_Ext.effectiveDate.value'),
            maxDate: _.get(wizardData, 'selectedData.mailingaddress') && _.get(submissionVM, 'baseData_Ext.periodEndDate.value')
        }
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    return (
        <WizardPage
            onNext={onNext}
            disableNext={!isComponentValid}
            showPrevious={false}
            cancelLabel={translator(appConfig.persona === 'policyholder' ? messages.cancelAllChanges : messages.cancel)}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={wizardData}
                overrideProps={overrideProps}
                classNameMap={resolvers.resolveClassNameMap}
                onModelChange={updateWizardData}
            />
        </WizardPage>
    );
}

TypeOfChangesPage.propTypes = wizardProps;

export default withRouter(TypeOfChangesPage);
